import { fromJS } from 'immutable'
import {
  STANDARD_PRICE_DEACTIVATE_REQUEST,
  STANDARD_PRICE_DEACTIVATE_SUCCESS,
  STANDARD_PRICE_DEACTIVATE_FAILURE,
  STANDARD_PRICE_DEACTIVATE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case STANDARD_PRICE_DEACTIVATE_REQUEST:
      return state
        .set('isFetching', true)
    case STANDARD_PRICE_DEACTIVATE_SUCCESS:
      return state
        .set('standardPriceDeactivate', fromJS(action.payload.deleteStandardPrice))
        .set('status', 200)
        .set('message', 'Deleted Successfully.')
        .set('isFetching', false)
    case STANDARD_PRICE_DEACTIVATE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('standardPriceDeactivate', fromJS(action.payload.message))
        .set('status', fromJS(action.payload.response.statusCode))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case STANDARD_PRICE_DEACTIVATE_RESET:
      return state
        .delete('standardPriceDeactivate')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/standard-price/standard-price-deactivate-reducer.js